import { render, staticRenderFns } from "./HoldBill.vue?vue&type=template&id=650951ee&"
import script from "./HoldBill.vue?vue&type=script&lang=js&"
export * from "./HoldBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HoldBill.vue"
export default component.exports